import { render, staticRenderFns } from "./ConfirmationDialog.vue?vue&type=template&id=0dea80ee&"
import script from "./ConfirmationDialog.vue?vue&type=script&lang=js&"
export * from "./ConfirmationDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports